<div class="audit-wrap">
  <div class="audit-header">
    <h1>Audit Log</h1>
    <p class="sub">A record of admin actions — who created, edited or deleted what, and why.</p>
  </div>

  <div class="filters">
    <mat-form-field appearance="outline" class="search">
      <mat-label>Search</mat-label>
      <input matInput [(ngModel)]="search" (ngModelChange)="applyFilters()"
        placeholder="Admin, entity, id, reason…">
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Action</mat-label>
      <mat-select [(ngModel)]="actionFilter" (ngModelChange)="applyFilters()">
        <mat-option value="">All</mat-option>
        <mat-option *ngFor="let a of actions" [value]="a">{{ a | titlecase }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Entity</mat-label>
      <mat-select [(ngModel)]="entityFilter" (ngModelChange)="applyFilters()">
        <mat-option value="">All</mat-option>
        <mat-option *ngFor="let e of entityTypes" [value]="e">{{ e | titlecase }}</mat-option>
      </mat-select>
    </mat-form-field>

    <button mat-stroked-button (click)="clearFilters()">Clear</button>
  </div>

  <div class="loading" *ngIf="loading">
    <mat-spinner diameter="36"></mat-spinner>
    <span>Loading audit log…</span>
  </div>

  <div class="empty" *ngIf="!loading && filtered.length === 0">
    No audit entries match your filters yet.
  </div>

  <div class="log-list" *ngIf="!loading">
    <div class="log-row" *ngFor="let log of filtered">
      <div class="log-main" (click)="toggle(log.id)">
        <span class="badge" [ngClass]="actionColor(log.action)">{{ log.action }}</span>
        <span class="entity">{{ log.entityType | titlecase }}</span>
        <span class="entity-id" [title]="log.entityId">{{ log.entityId }}</span>
        <span class="who">{{ log.performedBy }}</span>
        <span class="reason" *ngIf="log.reason" [title]="log.reason">“{{ log.reason }}”</span>
        <span class="spacer"></span>
        <span class="when">{{ formatDate(log.createdAt) }}</span>
        <mat-icon class="chev">{{ expanded[log.id] ? 'expand_less' : 'expand_more' }}</mat-icon>
      </div>

      <div class="log-detail" *ngIf="expanded[log.id]">
        <div class="meta-grid">
          <div><label>Path</label><code>{{ log.path }}</code></div>
          <div *ngIf="log.changedFields?.length">
            <label>Changed fields</label>
            <span>{{ log.changedFields.join(', ') }}</span>
          </div>
          <div><label>Admin UID</label><span>{{ log.performedByUid || '—' }}</span></div>
          <div><label>Company</label><span>{{ log.companyId || '—' }}</span></div>
        </div>

        <div class="diff" *ngIf="log.action !== 'create'">
          <div class="diff-col">
            <label>Before</label>
            <pre>{{ pretty(log.before) }}</pre>
          </div>
          <div class="diff-col" *ngIf="log.action !== 'delete'">
            <label>After</label>
            <pre>{{ pretty(log.after) }}</pre>
          </div>
        </div>
        <div class="diff" *ngIf="log.action === 'create'">
          <div class="diff-col">
            <label>Created</label>
            <pre>{{ pretty(log.after) }}</pre>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
